import { render, staticRenderFns } from "./genbyidea3.vue?vue&type=template&id=2df7a3da&scoped=true"
import script from "./genbyidea3.vue?vue&type=script&lang=js"
export * from "./genbyidea3.vue?vue&type=script&lang=js"
import style0 from "./genbyidea3.vue?vue&type=style&index=0&id=2df7a3da&prod&lang=css"
import style1 from "./genbyidea3.vue?vue&type=style&index=1&id=2df7a3da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df7a3da",
  null
  
)

export default component.exports